import ReferrerShareLanding from 'components/Content/ReferrerShareLanding/ReferrerShareLanding';

export default ReferrerShareLanding;
